import { render, staticRenderFns } from "./ProductSearch.vue?vue&type=template&id=5cda6181&scoped=true"
import script from "./ProductSearch.vue?vue&type=script&lang=js"
export * from "./ProductSearch.vue?vue&type=script&lang=js"
import style0 from "./ProductSearch.vue?vue&type=style&index=0&id=5cda6181&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cda6181",
  null
  
)

export default component.exports